import React from 'react';
import { Link } from 'react-router-dom';

function HomeArticle(props) {
    return (
      <>
        <div className={props.className}>

          <div className='hao_inner'>
            <div className='hao_inner_up'>

              <Link className='hao_link' to={`/article/${props.id}/${props.title.toLowerCase().replace(/\s+/g, '-')}`}><h3 className='hao_inner_title'>{props.title}</h3></Link>
              
            </div>
            <div className='hao_inner_down'>

              <p className='hao_inner_date'><span className="fa-regular fa-calendar"></span>&nbsp;{props.date}</p>

              <p className='hao_inner_authors'><strong>Authors:</strong> {props.authors}</p>
            </div>
          </div>
            

            
        </div>
      </>
    );
}

export default HomeArticle;